import api from '../ApiService';
export async function ecosystemRequest<T>(
  action: string,
  body?: unknown,
  query: Record<string, string> = {},
  area: 'collector' | 'admin' | 'operations' = 'collector'
): Promise<T> {
  const generation = api.sessionGeneration;
  const endpoint =
    area === 'admin'
      ? '/admin/passport_ecosystem.php'
      : area === 'operations'
        ? '/organizer/passport_operations.php'
        : '/passport_ecosystem.php';
  const r = await api.makeRequest<T>(
    `${endpoint}?${new URLSearchParams({ action, ...query })}`,
    body === undefined ? {} : { method: 'POST', body: JSON.stringify(body) }
  );
  if (generation !== api.sessionGeneration) throw new Error('Session changed');
  if (!r.success || r.data === undefined)
    throw new Error(r.error || 'Could not complete this request. Retry when connected.');
  return r.data;
}
export type ProgramSummary = {
  availability: string;
  next_action: string;
  benefit_policy?: string;
  public_id: string;
  title: string;
  instructions: string;
  city: string;
  timezone: string;
  joined: boolean;
  saved: boolean;
  starts_at: string | null;
  ends_at: string | null;
  version_ref: string;
};
export type RuleProgress = {
  completed: boolean;
  progress: number;
  target: number;
  reason: string | null;
  next_eligible_at?: string | null;
  children?: RuleProgress[];
};
export type ProgramDetail = {
  id: string;
  title: string;
  status: string;
  version_ref: string;
  instructions: string;
  timezone: string;
  starts_at: string | null;
  ends_at: string | null;
  terms: string;
  terms_version: string;
  joined: boolean;
  cycle: number | null;
  transitions: Array<{
    public_id: string;
    policy: string;
    explanation: string;
    instructions: string;
    terms: string;
    terms_version: string;
  }>;
  stops: Array<{
    subject_ref: string;
    subject: { title: string; subject_type: string };
    paused?: boolean;
    assistance: string[];
    session_required: boolean;
    sessions: Array<{
      public_id: string;
      title: string;
      starts_at: string;
      ends_at: string;
      timezone: string;
      status: string;
    }>;
  }>;
  progress: RuleProgress | null;
  reward: {
    title: string;
    stock_policy: string;
    funding_partner: string;
    fulfillment_partner: string;
  } | null;
};
export type RewardEntitlement = {
  public_id: string;
  title: string;
  description: string;
  state: string;
  cycle: number;
  expires_at: string;
  stock_policy: string;
  funding_partner: string;
  fulfillment_partner: string;
};
export type Challenge = { id: string; challenge?: string; expires_at: string; purpose: string; state?: string; receipt?: { receipt_ref?: string; visit_ref?: string } | null };
